import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { BsPeopleFill } from "react-icons/bs";
import { BiMessageSquareEdit, BiTrash } from "react-icons/bi";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { ModalContext } from "../../context/modal";
import { Skeleton } from "../../components/Skeleton/table";
import { authApi } from "../../services/api";
import MyTooltip from "../../components/Tooltip";
import { SectorContext } from "../../context/sectorFilter";
import { ModalAccountsCreate } from "./modal-create";
import { ModalAccountsEdit } from "./modal-edit";
import { DisableAccountModal } from "./modal-disabe";
import { MyHorizontalScrollView } from "./style";
import { debounce } from "../../utils/debounce";

function Accounts() {
	const { open, handleOpenModal } = useContext(ModalContext);
	const { configFilter } = useContext(SectorContext);
	const [isLoading, setIsLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [filteredAccounts, setFilteredAccounts] = useState([...tableData]);
	const [searchQuery, setSearchQuery] = useState("");
	const [modalData, setModalData] = useState({});
	const [accountModalCreate, setAccountModalCreate] = useState(false);
	const [accountModalEdit, setAccountModalEdit] = useState(false);
	const [accountModalDisable, setAccountModalDisable] = useState(false);
	const { push } = useHistory();

	const handleModalCreate = () => {
		setAccountModalCreate(true);
		setAccountModalEdit(false);
		setAccountModalDisable(false);
		handleOpenModal();
	};

	const handleModalEdit = () => {
		setAccountModalCreate(false);
		setAccountModalEdit(true);
		setAccountModalDisable(false);
		handleOpenModal();
	};

	const handleModalDisbale = () => {
		setAccountModalCreate(false);
		setAccountModalEdit(false);
		setAccountModalDisable(true);
		handleOpenModal();
	};

	const populateTable = async () => {
		try {
			setIsLoading(true);
			const { data } = await authApi.get("/account/all");
			setTableData(data);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		populateTable();
	}, []);

	useEffect(() => {
		const filtered = tableData.filter(
			(acc) =>
				acc._id.toLowerCase().includes(searchQuery.toLowerCase()) ||
				acc.name.toLowerCase().includes(searchQuery.toLowerCase())
		);
		setFilteredAccounts(filtered);
	}, [searchQuery, tableData]);

	const handleSearch = (event) => {
		const query = event.target.value;
		setSearchQuery(query);
	};

	return (
		<Page>
			{/* Modals */}
			{open && accountModalCreate && (
				<ModalAccountsCreate open={open} populateTable={populateTable} />
			)}
			{open && accountModalDisable && (
				<DisableAccountModal
					open={open}
					populateTable={populateTable}
					data={modalData}
				/>
			)}
			{open && accountModalEdit && (
				<ModalAccountsEdit
					open={open}
					populateTable={populateTable}
					data={modalData}
				/>
			)}
			<Sidebar activeMenu="accounts" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Clientes</span>
							<DefaultButton
								headerButton
								onClick={() => {
									handleModalCreate();
								}}
							>
								Cadastrar cliente
							</DefaultButton>
						</Apresentation>
						{isLoading ? (
							<Skeleton
								data={[
									"Cliente",
									"ADM EMAIL",
									"QUANTIDADE DE NÚMEROS",
									"VAZÃO DIÁRIA ATUAL",
									"VAZÃO DIÁRIA ESPERADA",
									"QTD ATENDENTES ATIVOS",
									"QTD ATENDENTES MAX.L",
								]}
							/>
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<input
											type="text"
											placeholder="Filtre pelo id ou nome"
											onChange={debounce(handleSearch, 1000)}
										/>
									</div>
								</MyHorizontalScrollView>

								{tableData && tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>id</th>
													<th>Cliente</th>
													<th>ADM Email</th>
													<th>Quantidade de números</th>
													<th>Vazão diária Atual</th>
													<th>Vazão diária Esperada</th>
													<th>Qtd Atendentes Ativos</th>
													<th>Qtd Atendentes Max.</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{filteredAccounts?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item?._id ? item?._id : "-"}</td>
														<td>{item?.name ? item?.name : "-"}</td>
														<td>
															{item?.name
																? item?.name
																		.normalize("NFD")
																		.replace(/[\u0300-\u036f]/g, "")
																		.replace(
																			/[[\].!'@,><|#:$%¨//\\;&*()_+=]/g,
																			""
																		)
																		.toLocaleLowerCase()
																		.trim()
																		.replace(/[\s]+/g, "-") +
																  "@" +
																  item.name
																		.normalize("NFD")
																		.replace(/[\u0300-\u036f]/g, "")
																		.replace(
																			/[[\].!'@,><|#:$%¨//\\;&*()_+=]/g,
																			""
																		)
																		.toLocaleLowerCase()
																		.trim()
																		.replace(/[\s]+/g, "-") +
																  ".com"
																: "-"}
														</td>
														<td>
															{item?.activeNumbers ? item?.activeNumbers : "-"}
														</td>
														<td>{item?.flowrate ? item?.flowrate : "-"}</td>
														<td>
															{item?.expectedFlowrate
																? item?.expectedFlowrate
																: "-"}
														</td>
														<td>
															{item?.activeOperators
																? item?.activeOperators
																: "-"}
														</td>
														<td>
															{item?.operatorLimit ? item?.operatorLimit : "-"}
														</td>
														<td
															style={{
																display: "flex",
																justifyContent: "space-between",
															}}
														>
															<MyTooltip
																label={`Ir para Setores de: ${item.name}`}
															>
																<DefaultButton
																	onClick={() => {
																		configFilter({
																			label: item.name,
																			value: item._id,
																		});
																		push("/sectors");
																	}}
																>
																	<BsPeopleFill size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label={`Editar: ${item.name}`}>
																<DefaultButton
																	onClick={() => {
																		handleModalEdit();
																		setModalData(item);
																	}}
																>
																	<BiMessageSquareEdit size={20} />
																</DefaultButton>
															</MyTooltip>
															<MyTooltip label={`Desativar: ${item.name}`}>
																<DefaultButton
																	onClick={() => {
																		handleModalDisbale();
																		setModalData(item);
																	}}
																>
																	<BiTrash size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default Accounts;
